import { request } from '../main'

/**
 * 获取基础配置
 */
export function getBasicConfig () {
  return request('basicConfigGet', null, 'PBBasicConfig')
}



// WEBPACK FOOTER //
// ./src/api/config.js